var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as go from '../../../../libs/gojs/release/go';
import { NodeElement } from './base/node-element';
import { DiagramConsts } from '../diagram-consts';
import { GraphService } from '../../../../shared/gallery/graph.service';
var HyperlinkElement = /** @class */ (function (_super) {
    __extends(HyperlinkElement, _super);
    function HyperlinkElement(injector) {
        var _this = _super.call(this, injector) || this;
        _this.graphService = injector.get(GraphService);
        return _this;
    }
    HyperlinkElement.prototype.compile = function (model, data, svg) {
        model['version'] = 4;
        model['angle'] = data.angle;
        model['size'] = this.sizeService.parse(data.size);
        model['useGraph'] = data.useGraph;
        model['linkAddress'] = data.linkAddress;
        model['graphSetting'] = data.graphSetting;
        model['font'] = data.font;
        model['fontSize'] = data.fontSize;
        model['isUnderline'] = data.isUnderline;
        model['stroke'] = data.stroke;
        model['textAlign'] = data.textAlign;
        model['text'] = data.text;
        if (this.hasDynamicSetting(data)) {
            model['dynamicSetting'] = data.dynamicSetting;
            model['location'] = go.Point.parse(data.loc);
            model['fixedPositionType'] = data.fixedPositionType;
        }
        svg.children().remove();
    };
    HyperlinkElement.prototype.getPaletteTemplate = function () {
        var $ = go.GraphObject.make;
        return $(go.Node, 'Vertical', { width: 50, height: 90, locationSpot: go.Spot.Center }, $(go.Picture, {
            margin: 10,
            source: '/assets/common/images/configure/elements/hyperlink.png'
        }), $(go.TextBlock, {
            alignment: go.Spot.Center,
            text: this.l(this.getCategoryKey()),
            editable: false
        }));
    };
    HyperlinkElement.prototype.getDiagramTemplate = function () {
        var _this = this;
        var $ = go.GraphObject.make;
        return $(go.Node, 'Auto', {
            locationObjectName: 'SHAPE', locationSpot: go.Spot.TopLeft, resizable: true, rotatable: true,
            selectionAdornmentTemplate: $(go.Adornment, 'Spot', $(go.Panel, go.Panel.Auto, $(go.Shape, { fill: null, stroke: 'dodgerblue', strokeWidth: 1 }, new go.Binding('stroke', 'locked', function (locked) { return locked ? '#f65177' : 'dodgerblue'; })), $(go.Placeholder)))
        }, new go.Binding('locationSpot', '', function (data) {
            return _this.getFixedPositionType(data);
        }), new go.Binding('angle').makeTwoWay(), new go.Binding('movable', 'locked', function (locked) { return !locked; }), new go.Binding('resizable', 'locked', function (locked) { return !locked; }), new go.Binding('deletable', 'locked', function (locked) { return !locked; }), new go.Binding('rotatable', 'locked', function (locked) { return !locked; }), new go.Binding('desiredSize', 'size', go.Size.parse).makeTwoWay(go.Size.stringify), new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify), new go.Binding('zOrder'), $(go.Shape, { fill: 'transparent', stroke: 'gray', strokeWidth: 0.5, strokeDashArray: [4, 4] }, new go.Binding('visible', 'useGraph', function (useGraph) { return !useGraph; })), $(go.Panel, go.Panel.Spot, $(go.Picture, { name: 'IMAGE' }, { sourceCrossOrigin: function (__) { return 'anonymous'; } }, new go.Binding('desiredSize', 'size', go.Size.parse).makeTwoWay(go.Size.stringify), new go.Binding('source', 'graphSetting', function (setting, __) { return _this.graphService.getCustomStyleGraphUrl(setting); }), new go.Binding('visible', 'useGraph')), $(go.TextBlock, {
            alignment: go.Spot.Center,
            minSize: new go.Size(40, 10),
            font: '16px Microsoft Yahei',
            margin: 10,
            editable: false,
            verticalAlignment: go.Spot.Center
        }, new go.Binding('desiredSize', 'size', go.Size.parse).makeTwoWay(go.Size.stringify), new go.Binding('textAlign').makeTwoWay(), new go.Binding('text').makeTwoWay(), new go.Binding('font', 'font', function (data) { return _this.setEditTextFontFamilyMustBeYaHei(data); }), new go.Binding('isUnderline').makeTwoWay(), new go.Binding('stroke').makeTwoWay())));
    };
    HyperlinkElement.prototype.setEditTextFontFamilyMustBeYaHei = function (font) {
        var fontArray = font.split('px');
        fontArray.pop();
        fontArray.push(' Microsoft YaHei,msyh');
        return fontArray.join('px');
    };
    HyperlinkElement.prototype.getCategoryKey = function () {
        return DiagramConsts.elements.hyperlinkKey;
    };
    return HyperlinkElement;
}(NodeElement));
export { HyperlinkElement };
